
import { defineComponent } from "vue";
import dayjs from "dayjs";
import ListManager from "@/components/cigo-admin-core/pages/template/ListManager.vue";

export default defineComponent({
    name: "User",
    components: {
        ListManager
    },
    setup(props) {
        const columns = [
            {
                title: "编号",
                dataIndex: "id",
                width: "80px"
            },
            {
                title: "手机号",
                dataIndex: "phone",
                width: "150px"
            },
            {
                title: "注册时间",
                dataIndex: "create_time",
                width: "180px",
                slots: {
                    customRender: "createTime"
                }
            }
        ];
        let columnsSlots = [
            {
                slot: "createTime"
            }
        ];

        return {
            dayjs,
            columns,
            columnsSlots
        };
    }
});
